<template>
	<!-- star -->

	<div class="aboutUs_wrap">
		<nav2></nav2>
		<!-- 面包屑 -->
		<!--<div class="Crumbs">-->
			<!--<div>当前位置：产品案例><span>信息采集平台</span></div>-->
		<!--</div>-->
		<!--<div class="navWrap_center_img">-->
		<banner2 :bannerH="h1" :bannerImg="Img1"></banner2>
		<!--</div>-->
		<div class="middle">
			<h1>企业简介</h1>
			<b class="watermark">COMPANY PROFILE</b>
			<p>北京弘易信泰科技发展有限公司，成立于2009年，过去十五年，在软件与信息行业，服务政企客户，应用大数据、人工智能、云计算等科技，为客户提供产品与解决方案，助力客户，实现信息化时代的持续发展目标。</p>
			<p>公司团队，拥有丰富技术实施和客户服务的经验，围绕客户的信息化需求，在不同行业与日常工作场景，运用信息化创新科技，我们赋能客户，无论是公司的产品还是解决方案，都致力于让客户在效率、安全和决策方面获得实实在在的收益。</p>
			<p>二十一世纪，科技高速发展，市场持续掀起数字化变革的浪潮，回顾过往，我们始终注重，科技与创新的结合；面对客户，我们始终坚持，提供有价值、安全、易用的软件与服务；迎接未来，我们脚踏实地，为客户创造更大价值。</p>
			<!--<img src="../assets/img/aboutUs/contact.png" alt="" />-->
		</div>
		<div class="middle1">
			<h1>发展历程</h1>
			<b class="watermark">COMPANY HISTORY</b>
			<img src="../assets/img/aboutUs/historyLine.png" alt="" />
		</div>
		<div class="container">
			<h1>认证与资质</h1>
			<b class="watermark">CERTIFICATION</b>
      <div class="grid-container">
        <svg width="172px" height="25px" viewBox="0 0 172 25" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <title>编组 3</title>
          <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="资质荣誉" transform="translate(-874.000000, -165.000000)">
              <g id="编组-3" transform="translate(875.000000, 165.000000)">
                <line x1="40" y1="12.5" x2="-1.9095836e-13" y2="12.5" id="直线" stroke="#365CE8" stroke-linecap="square"></line>
                <line x1="170" y1="12.5" x2="130" y2="12.5" id="直线备份" stroke="#365CE8" stroke-linecap="square"></line>
                <text id="资质" font-family="AlibabaPuHuiTi-Medium, Alibaba PuHuiTi" font-size="18" font-weight="400" letter-spacing="1.8" fill="#365CE8">
                  <tspan x="65.488" y="19">资质</tspan>
                </text>
                <rect id="矩形" stroke="#365CE8" fill="#365CE8" transform="translate(124.000000, 13.000000) rotate(45.000000) translate(-124.000000, -13.000000) " x="119.5" y="8.5" width="9" height="9" rx="2"></rect>
                <rect id="矩形备份-2" stroke="#365CE8" fill="#365CE8" transform="translate(46.000000, 13.000000) rotate(45.000000) translate(-46.000000, -13.000000) " x="41.5" y="8.5" width="9" height="9" rx="2"></rect>
              </g>
            </g>
          </g>
        </svg>
        </div>
		<div class="grid-container">
				<div class="grid-item">
					<div ><img src="../assets/img/aboutUs/1.png" alt="" /></div>
				</div>
				<div class="grid-item">
					<div><img src="../assets/img/aboutUs/3.png" alt="" /></div>
				</div>
				<div class="grid-item">
					<div><img src="../assets/img/aboutUs/2.png" alt="" /></div>
				</div>
				<div class="grid-item">
					<div><img src="../assets/img/aboutUs/4.png" alt="" /></div>
				</div>
				<div class="grid-item">
					<div><img src="../assets/img/aboutUs/6.png" alt="" /></div>
				</div>
				<div class="grid-item">
					<div><img src="../assets/img/aboutUs/10.png" alt="" /></div>
				</div>
		</div>

      <div class="grid-container">
        <svg width="172px" height="25px" viewBox="0 0 172 25" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <title>编组 3备份</title>
          <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="资质荣誉" transform="translate(-874.000000, -450.000000)">
              <g id="编组-3备份" transform="translate(875.000000, 450.000000)">
                <line x1="40" y1="12.5" x2="-1.9095836e-13" y2="12.5" id="直线" stroke="#ED781B" stroke-linecap="square"></line>
                <line x1="170" y1="12.5" x2="130" y2="12.5" id="直线备份" stroke="#ED781B" stroke-linecap="square"></line>
                <text id="荣誉" font-family="AlibabaPuHuiTi-Medium, Alibaba PuHuiTi" font-size="18" font-weight="400" letter-spacing="1.8" fill="#ED781B">
                  <tspan x="65.488" y="19">荣誉</tspan>
                </text>
                <rect id="矩形" stroke="#ED781B" fill="#ED781B" transform="translate(124.000000, 13.000000) rotate(45.000000) translate(-124.000000, -13.000000) " x="119.5" y="8.5" width="9" height="9" rx="2"></rect>
                <rect id="矩形备份-2" stroke="#ED781B" fill="#ED781B" transform="translate(46.000000, 13.000000) rotate(45.000000) translate(-46.000000, -13.000000) " x="41.5" y="8.5" width="9" height="9" rx="2"></rect>
              </g>
            </g>
          </g>
        </svg>
        </div>
      <div class="grid-container">
        <div class="grid-item">
        <div ><img src="../assets/img/aboutUs/11.png" alt="" /></div>
        </div>
        <div class="grid-item">
        <div ><img src="../assets/img/aboutUs/9.png" alt="" /></div>
        </div>
        <div class="grid-item">
        <div ><img src="../assets/img/aboutUs/7.png" alt="" /></div>
        </div>
        <div class="grid-item">
        <div ><img src="../assets/img/aboutUs/8.png" alt="" /></div>
        </div>
        <div class="grid-item">
        <div ><img src="../assets/img/aboutUs/5.png" alt="" /></div>
        </div>
        <div class="grid-item">
        <div ><img src="../assets/img/aboutUs/12.png" alt="" /></div>
        </div>

      </div>

		</div>


		<!-- 客户关系 -->
		<div class="CooperativePartner">
			<div class="CooperativePartner_cont">
				<h1>客户关系</h1>
				<b class="watermark1">PANRTNER</b>
			</div>
			<!--<div class="CooperativePartner_cont_center">-->
				<!--<div class="CooperativePartner_cont_center_item">-->
					<!--<img src="../assets/img/合作1.png" alt="" />-->
					<!--<span>合作院校</span>-->
				<!--</div>-->
				<!--<div class="CooperativePartner_cont_center_item">-->
					<!--<img src="../assets/img/合作2.png" alt="" />-->
					<!--<span>合作院校</span>-->
				<!--</div>-->
			<!--</div>-->
			<!--<div class="CooperativePartner_cont_bottom">-->
				<!--<div-->
						<!--v-for="(item, index) in logoList"-->
						<!--:key="index"-->
						<!--class="CooperativePartner_cont_bottom_logo"-->
				<!--&gt;-->
					<!--<img :src="item.logo" alt="" />-->
				<!--</div>-->
			<!--</div>-->
			<div class="grid-container1">
				<div class="grid-item1">
					<div ><img src="../assets/img/aboutUs/partner/c1.png" alt="" /></div>
					<div><img src="../assets/img/aboutUs/partner/c2.png" alt="" /></div>
					<div><img src="../assets/img/aboutUs/partner/c3.png" alt="" /></div>
					<div><img src="../assets/img/aboutUs/partner/c4.png" alt="" /></div>
				</div>
				<div class="grid-item1">
					<div><img src="../assets/img/aboutUs/partner/c5.png" alt="" /></div>
<!--					<div><img src="../assets/img/aboutUs/partner/c6.png" alt="" /></div>-->
					<div><img src="../assets/img/aboutUs/partner/c7.png" alt="" /></div>
				</div>
			</div>
		</div>

		<!-- footer -->
		<footer2></footer2>
		<!-- end -->
	</div>
</template>

<script>
import footer2 from "../components/footer.vue";
import banner2 from "../components/banner.vue";
import nav2 from "../components/nav.vue";
export default {
	name: "us",
	components: {
		footer2,
		nav2,
		banner2,
	},
	data() {
		return {
			// h1: "集团产业 · 集团产业",
			Img1: require("../assets/img/aboutUs/aboutUsBanner.png"),
			arrList: [
				{
					url: require("../assets/img/infoc/产品优势_实时处理和流式计算.png"),
				},
				{
					url: require("../assets/img/infoc/产品优势_安全性和合规性.png"),
				},
				{
					url: require("../assets/img/infoc/产品优势_多源数据集成.png"),
				},
				{
					url: require("../assets/img/infoc/产品优势_可扩展性和灵活性.png"),
				},
			],
			logoList: [
				{ logo: require("../assets/img/aboutUs/partner/c1.png") },
				{ logo: require("../assets/img/aboutUs/partner/c2.png") },
				{ logo: require("../assets/img/aboutUs/partner/c3.png") },
				{ logo: require("../assets/img/aboutUs/partner/c4.png") },
				{ logo: require("../assets/img/aboutUs/partner/c5.png") },
				{ logo: require("../assets/img/aboutUs/partner/c6.png") },
				{ logo: require("../assets/img/aboutUs/partner/c7.png") },
			],
		};
	},
	methods: {},
};
</script>
<style scoped>
@charset "utf-8";
/*=========================Reset_start==========================*/
body,
h1,
h2,
h3,
h4,
h5,
h6,
div,
p,
dl,
dt,
dd,
ol,
ul,
li,
form,
table,
th,
td,
a,
img,
span,
strong,
var,
em,
input,
textarea,
select,
option {
	margin: 0;
	padding: 0;
}
/*去内外边距*/
html,
body {
	font-family: "微软雅黑", "宋体", Arail, Tabhoma;
	text-align: left;
}
/*字体 文本居左*/
ul {
	list-style: none;
}
/*去ul li 小点*/
img {
	border: 0 none;
}
/*img IE6 兼容问题*/
input,
select,
textarea {
	outline: 0;
}
/*去除点击蓝框*/
textarea {
	resize: none;
	overflow: auto;
}
/*锁定多行文本框大小 与文字超出出现滚动条*/
table {
	border-collapse: collapse;
	border-spacing: 0;
}
/*表格边框合并 边框间距0*/
th,
strong,
var,
em {
	font-weight: normal;
	font-style: normal;
}
/*特殊文字粗细 样式显示正常*/
a {
	text-decoration: none;
}
/*a标签去下划线*/
.clearfix:after {
	clear: both;
	content: "";
	display: block;
	height: 0;
}
/*清浮动*/
a {
	color: #000000;
}
/*==========================Reset_End===========================*/
.watermark {
	position: relative;
	/*bottom: 10px;*/
	/*right: 10px;*/
	margin-top: -250px;
	text-align: center;
	color: #EAEEFC;
	font-size: 80px;
	font-family:AlibabaPuHuiTi-3-55-Regular;
	opacity: 0.5;
	top:120px;
	z-index: 1;
}
.watermark1 {
	position: relative;
	/*bottom: 10px;*/
	/*right: 10px;*/
	/*margin-top: -550px;*/
	text-align: center;
	color: #EAEEFC;
	font-size: 80px;
	font-family:AlibabaPuHuiTi-3-55-Regular;
	opacity: 0.5;
	top:-50px;
	z-index: 1;
}
.title{
	position: relative;
	text-align: center;
	font-family: AlibabaPuHuiTi-3-55-Regular;
	margin-top:-50px;
	margin-bottom: 80px;
	z-index: 3
}
.container {
	position:relative;
	display: grid;
	background-color: #F8F9FC;
	width: 1920px;
	height: auto;
	/*margin:0 auto;*/
}
@media screen and (max-device-width: 1900px) {
	.container {
		height: auto;
		width: 1680px;
	}
}
@media screen and (max-device-width: 1500px) {
	.container {
		height: auto;
		width: 1440px;
	}
}
@media screen and (max-device-width: 1400px) {
	.container {
		height: auto;
		width: 1366px;
	}
}
@media screen and (max-device-width: 1300px) {
	.container {
		height: auto;
		width: 1280px;
	}
}
@media screen and (min-device-width: 2000px) {
	.container {
		height: auto;
		width: 2560px;
	}
}
.container img{
	width: 196px;
	height: auto;
	margin:0 auto;
	display: flex;
	justify-content: space-between;

}
.container h1 {
	font-size: 40px;
	font-family:AlibabaPuHuiTi-3-55-Regular;
	font-weight: 600;
	color: #444444;
	/*background-color: #F8F9FC;*/
	line-height: 45px;
	text-align: center;
	top: revert;
	margin-top: 200px;
	margin-bottom: 80px;
	position: relative;
	z-index: 2;
	/*font-size: 32px;*/
	/*font-family:AlibabaPuHuiTi-3-55-Regular;*/
	/*font-weight: 500;*/
	/*color: #444444;*/
	/*background-color: #F8F9FC;*/
	/*line-height: 45px;*/
	/*text-align: center;*/
	/*top: revert;*/
	/*margin-top: 200px;*/
	/*margin-bottom: 80px;*/
}
.grid-container {
	display: flex;
	width: 100%;
	justify-content: center;
	/*text-align:-moz-center;*/
	background-color: #F8F9FC;
	/*grid-template-columns: repeat(4, 1fr);*/
	/*grid-template-rows: repeat(1, 1fr);*/
}
.grid-item {
	/*text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);*/
	background-color: #F8F9FC;
	color: #fff;
	/*width: 314px;*/
	/*justify-content: center;*/
	/*text-align: center;*/
	/*padding: 30px 80px;*/
}
.grid-container1 {
	display: grid;
	width: 100%;
	justify-content: center;
	grid-gap: 30px;
	/*background-color: #F8F9FC;*/
	/*grid-template-columns: repeat(2, 1fr);*/
	/*grid-template-rows: repeat(2, 1fr);*/
}
.grid-item1 {
	display: flex;
	/*background-color: #ccc;*/
	/*text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);*/
	/*background-color: #F8F9FC;*/
	color: #fff;
	width: 220px;
	justify-content: center;
	grid-gap: 30px;
	/*text-align: center;*/
	/*padding: 30px 80px;*/
}
.middle{
	position:relative;
	display: grid;
	background: #F8F9FC;
	width: 1920px;
	/*margin:0 auto;*/
	/*text-align: center;*/
	justify-content: center;
	/*grid-template-rows: repeat(2, 0.5fr);*/
	/*grid-template-columns: repeat(1, 1fr);*/
	/*margin-bottom:20px;*/
}
@media screen and (max-device-width: 1900px) {
	.middle {
		height: auto;
		width: 1680px;
	}
}
@media screen and (max-device-width: 1500px) {
	.middle {
		height: auto;
		width: 1440px;
	}
}
@media screen and (max-device-width: 1400px) {
	.middle {
		height: auto;
		width: 1366px;
	}
}
@media screen and (max-device-width: 1300px) {
	.middle {
		height: auto;
		width: 1280px;
	}
}
@media screen and (min-device-width: 2000px) {
	.middle {
		height: auto;
		width: 2560px;
	}
}
.middle img{
	width: 1200px;
	/*height: auto;*/
	/*margin:0 auto;*/
	display: flex;
	justify-content: space-between;

}

.middle h1 {
	font-size: 40px;
	font-family:AlibabaPuHuiTi-3-55-Regular;
	font-weight: 600;
	color: #444444;
	/*background-color: #F8F9FC;*/
	line-height: 45px;
	text-align: center;
	top: revert;
	margin-top: 200px;
	margin-bottom: 80px;
	position: relative;
	z-index: 2;
}
.middle p{
	/*margin-top: 250px;*/
	width: 1100px;
	font-size: 16px;
	font-family: AlibabaPuHuiTi-3-55-Regular;
	font-weight: 400;
	/*text-align: center;*/
	/*color: #ffffff;*/
	line-height: 40px;
}


.middle1{
	position:relative;
	display: grid;
	background: #F8F9FC;
	width: 1920px;
	/*margin:0 auto;*/
	/*text-align: center;*/
	justify-content: center;
	/*grid-template-rows: repeat(2, 0.5fr);*/
	/*grid-template-columns: repeat(1, 1fr);*/
	/*margin-bottom:20px;*/
}
@media screen and (max-device-width: 1900px) {
	.middle1 {
		height: auto;
		width: 1680px;
	}
}
@media screen and (max-device-width: 1500px) {
	.middle1 {
		height: auto;
		width: 1440px;
	}
}
@media screen and (max-device-width: 1400px) {
	.middle1 {
		height: auto;
		width: 1366px;
	}
}
@media screen and (max-device-width: 1300px) {
	.middle1 {
		height: auto;
		width: 1280px;
	}
}
@media screen and (min-device-width: 2000px) {
	.middle1 {
		height: auto;
		width: 2560px;
	}
}
.middle1 h1 {
	font-size: 40px;
	font-family:AlibabaPuHuiTi-3-55-Regular;
	font-weight: 600;
	color: #444444;
	/*background-color: #F8F9FC;*/
	line-height: 45px;
	text-align: center;
	top: revert;
	margin-top: 200px;
	margin-bottom: 80px;
	position: relative;
	z-index: 2;
}
.middle1 img{
	width: 1100px;
	/*height: auto;*/
	/*margin:0 auto;*/
	display: flex;
	justify-content: space-between;

}
.aboutUs_wrap {
	width: 100%;
	margin: 0 auto;
	height: auto;
	/*background-position: right bottom, left top;*/
}
/* 合作伙伴 */
.CooperativePartner {
	/*width: 100vw;*/
	/*height: 798px;*/
	width: 100vw;
	height: auto;
	background-image: url("../assets/img/aboutUs/partner/cback.png");
	background-size: 1920px;
}
@media screen and (max-device-width: 1900px) {
	.CooperativePartner {
		height: auto;
		width: 1680px;
		background-size: 1680px;
	}
}
@media screen and (max-device-width: 1500px) {
	.CooperativePartner {
		height: auto;
		width: 1440px;
		background-size: 1440px;
	}
}
@media screen and (max-device-width: 1400px) {
	.CooperativePartner {
		height: auto;
		width: 1366px;
		background-size: 1366px;
	}
}
@media screen and (max-device-width: 1300px) {
	.CooperativePartner {
		height: auto;
		width: 1280px;
		background-size: 1280px;
	}
}
@media screen and (min-device-width: 2000px) {
	.CooperativePartner {
		height: auto;
		width: 2560px;
		background-size: 2560px;
	}
}
.CooperativePartner_cont {
	position: relative;
	text-align: center;
	/*width: 1200px;*/
	margin: 0 auto;
}
.CooperativePartner h1 {
	font-size: 40px;
	font-family:AlibabaPuHuiTi-3-55-Regular;
	font-weight: 600;
	color: #444444;
	/*background-color: #F8F9FC;*/
	line-height: 45px;
	text-align: center;
	top: revert;
	margin-top: 200px;
	/*margin-bottom: 80px;*/
	position: relative;
	z-index: 2;
}
.CooperativePartner_cont_center {
	display: flex;
	justify-content: space-between;
	width: 365px;
	height: 69px;

	margin: 0 auto;
	margin-top: 47px;
}
.CooperativePartner_cont_center_item {
	display: flex;
	align-items: center;
}
.CooperativePartner_cont_center_item:hover {
	border-bottom: 1px solid #3491e5;
}
.CooperativePartner_cont_center_item img {
	width: 40px;
	height: 40px;
}
.CooperativePartner_cont_center_item span {
	line-height: 69px;
	font-size: 24px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #23337f;
	line-height: 33px;
	margin-left: 14px;
}
.CooperativePartner_cont_bottom {
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	width: 70%;
	height: 220px;
	margin: 0 auto;
	margin-bottom: 90px;
}
.CooperativePartner_cont_bottom_logo img {
	width: 196px;
	height: auto;
	/*background: #ffffff;*/
	/*box-shadow: 0px 0px 12px -2px rgba(0, 0, 0, 0.12);*/
	border-radius: 9px;
	margin-bottom: 16px;
}
</style>
